import { CancelQuoteAction } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/cancel';
import { PriceQuoteAction } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/price';

export function ExpiredQuoteActions() {
  return (
    <div className="flex-x gap-2 w-100">
      <PriceQuoteAction
        labelTranslationKey="sidePanel.actions.reprice"
        className="w-100"
        purpose="discreet"
        color="secondary"
      />
      <CancelQuoteAction className="w-100" isDismiss />
    </div>
  );
}
